(function () {
  "use strict";
  var KEY = "dhajia_saved_stays_v1";
  var body = document.body;
  var shell, itemsNode, emptyNode;
  function read() {
    try {
      var value = JSON.parse(localStorage.getItem(KEY) || "[]");
      return Array.isArray(value) ? value : [];
    } catch (error) { return []; }
  }
  function write(items) {
    try { localStorage.setItem(KEY, JSON.stringify(items)); } catch (error) {}
    update();
  }
  function normalise(url) {
    try {
      var parsed = new URL(url, window.location.origin);
      parsed.search = "";
      parsed.hash = "";
      return parsed.pathname;
    } catch (error) { return url; }
  }
  function saved(url) {
    var key = normalise(url);
    return read().some(function (item) { return normalise(item.url) === key; });
  }
  function toggle(item) {
    var key = normalise(item.url);
    var list = read();
    var index = list.findIndex(function (entry) { return normalise(entry.url) === key; });
    if (index > -1) list.splice(index, 1);
    else list.unshift({ url: key, title: item.title || "DHAJIA stay", image: item.image || "" });
    write(list);
  }
  function createHeart(className, item, label) {
    var button = document.createElement("button");
    button.type = "button";
    button.className = className + (saved(item.url) ? " is-saved" : "");
    if (className === "dhajia-card-heart") button.style.zIndex = "30";
    button.setAttribute("aria-label", label || "Save this stay");
    button.dataset.dhajiaSaveStay = "true";
    button.dataset.url = item.url;
    button.dataset.title = item.title || "";
    button.dataset.image = item.image || "";
    button.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78Z"></path></svg><span class="dhajia-save-label">' + (saved(item.url) ? "Saved" : "Save") + "</span>";
    return button;
  }
  function injectCards() {
    var roots = document.querySelectorAll(".collection-product-card, .card-wrapper");
    roots.forEach(function (root) {
      if (root.dataset.dhajiaWishlistReady) return;
      if (root.dataset.dhajiaProductKind === "activity") return;
      if (root.querySelector('[data-dhajia-save-stay]')) {
        root.dataset.dhajiaWishlistReady = "true";
        return;
      }
      var link = root.querySelector('a[href*="/products/"]');
      if (!link) return;
      root.dataset.dhajiaWishlistReady = "true";
      var titleNode = root.querySelector(".card__title");
      var image = root.querySelector("img");
      var item = {
        url: normalise(link.href),
        title: titleNode ? titleNode.textContent.trim() : (link.getAttribute("title") || link.textContent.trim()),
        image: image ? (image.currentSrc || image.src) : ""
      };
      var target = root.querySelector(".card-wrapper__media, .card__inner, .media") || root;
      target.appendChild(createHeart("dhajia-card-heart", item, "Save " + item.title));
    });
  }
  function injectProduct() {
    if (!body.classList.contains("template-product")) return;
    if (document.querySelector(".main-product--experience")) return;
    if (document.querySelector(".dhajia-product-save")) return;
    var canonical = document.querySelector('link[rel="canonical"]');
    var title = document.querySelector("h1, .dhajia-stay-title");
    var image = document.querySelector('meta[property="og:image"]');
    var target = document.querySelector(".dhajia-stay-info, .product__info-container, .product__info-wrapper");
    if (!canonical || !target) return;
    var item = {
      url: normalise(canonical.href),
      title: title ? title.textContent.trim() : document.title,
      image: image ? image.content : ""
    };
    var button = createHeart("dhajia-product-save", item, "Save this stay");
    var lead = target.querySelector(".dhajia-stay-lead");
    if (lead && lead.nextSibling) target.insertBefore(button, lead.nextSibling);
    else target.appendChild(button);
  }
  function makeItem(item) {
    var row = document.createElement("article");
    row.className = "dhajia-wishlist-item";
    var link = document.createElement("a");
    link.href = item.url;
    link.className = "dhajia-wishlist-item__link";
    if (item.image) {
      var img = document.createElement("img");
      img.src = item.image;
      img.alt = "";
      img.loading = "lazy";
      link.appendChild(img);
    }
    var title = document.createElement("span");
    title.textContent = item.title;
    link.appendChild(title);
    var remove = document.createElement("button");
    remove.type = "button";
    remove.className = "dhajia-wishlist-remove";
    remove.textContent = "Remove";
    remove.dataset.dhajiaRemoveStay = item.url;
    row.appendChild(link);
    row.appendChild(remove);
    return row;
  }
  function update() {
    var list = read();
    document.querySelectorAll("[data-dhajia-wishlist-count]").forEach(function (node) {
      node.textContent = String(list.length);
      node.hidden = list.length === 0;
    });
    document.querySelectorAll("[data-dhajia-save-stay]").forEach(function (button) {
      var active = saved(button.dataset.url);
      button.classList.toggle("is-saved", active);
      button.setAttribute("aria-label", active ? "Remove from saved stays" : "Save this stay");
      var label = button.querySelector(".dhajia-save-label");
      if (label) label.textContent = active ? "Saved" : "Save";
    });
    if (!itemsNode) return;
    itemsNode.textContent = "";
    list.forEach(function (item) { itemsNode.appendChild(makeItem(item)); });
    if (emptyNode) emptyNode.hidden = list.length > 0;
  }
  function openDrawer() {
    if (!shell) return;
    shell.hidden = false;
    requestAnimationFrame(function () { shell.classList.add("is-open"); });
    body.classList.add("dhajia-wishlist-open");
    document.querySelectorAll("[data-dhajia-wishlist-open]").forEach(function (button) { button.setAttribute("aria-expanded", "true"); });
  }
  function closeDrawer() {
    if (!shell) return;
    shell.classList.remove("is-open");
    body.classList.remove("dhajia-wishlist-open");
    document.querySelectorAll("[data-dhajia-wishlist-open]").forEach(function (button) { button.setAttribute("aria-expanded", "false"); });
    window.setTimeout(function () { if (!shell.classList.contains("is-open")) shell.hidden = true; }, 250);
  }
  function init() {
    shell = document.querySelector("[data-dhajia-wishlist-shell]");
    if (shell && shell.parentNode !== body) body.appendChild(shell);
    itemsNode = document.querySelector("[data-dhajia-wishlist-items]");
    emptyNode = document.querySelector("[data-dhajia-wishlist-empty]");
    injectCards();
    injectProduct();
    update();
    document.addEventListener("click", function (event) {
      var open = event.target.closest("[data-dhajia-wishlist-open]");
      if (open) { event.preventDefault(); openDrawer(); return; }
      var close = event.target.closest("[data-dhajia-wishlist-close]");
      if (close) { event.preventDefault(); closeDrawer(); return; }
      var save = event.target.closest("[data-dhajia-save-stay]");
      if (save) {
        event.preventDefault();
        event.stopPropagation();
        toggle({ url: save.dataset.url, title: save.dataset.title, image: save.dataset.image });
        return;
      }
      var remove = event.target.closest("[data-dhajia-remove-stay]");
      if (remove) {
        event.preventDefault();
        var list = read().filter(function (item) { return normalise(item.url) !== normalise(remove.dataset.dhajiaRemoveStay); });
        write(list);
      }
    }, true);
    document.addEventListener("keydown", function (event) { if (event.key === "Escape") closeDrawer(); });
    document.addEventListener("shopify:section:load", function () { injectCards(); injectProduct(); update(); });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
